export const interFontFamily =
  "Inter, Roboto, 'Helvetica Neue', 'Arial Nova', 'Nimbus Sans', Arial, sans-serif";

const fontFamily = interFontFamily;

export const fontStyles = {
  displayLargeNormal: {
    fontFamily,
    fontSize: 28,
    fontWeight: '400',
    lineHeight: '48px'
  },
  displayLargeMedium: {
    fontFamily,
    fontSize: 28,
    fontWeight: '500',
    lineHeight: '48px'
  },
  displayLargeSemibold: {
    fontFamily,
    fontSize: 28,
    fontWeight: '600',
    lineHeight: '48px'
  },
  displayLargeBold: {
    fontFamily,
    fontSize: 28,
    fontWeight: '700',
    lineHeight: '48px'
  },
  displayRegularNormal: {
    fontFamily,
    fontSize: 20,
    fontWeight: '400',
    lineHeight: '34px'
  },
  displayRegularMedium: {
    fontFamily,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: '34px'
  },
  displayRegularSemibold: {
    fontFamily,
    fontSize: 20,
    fontWeight: '600',
    lineHeight: '34px'
  },
  displayRegularBold: {
    fontFamily,
    fontSize: 20,
    fontWeight: '700',
    lineHeight: '34px'
  },
  displaySmallNormal: {
    fontFamily,
    fontSize: 20,
    fontWeight: '400',
    lineHeight: '24px'
  },
  displaySmallMedium: {
    fontFamily,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: '24px'
  },
  displaySmallSemibold: {
    fontFamily,
    fontSize: 20,
    fontWeight: '600',
    lineHeight: '24px'
  },
  displaySmallBold: {
    fontFamily,
    fontSize: 20,
    fontWeight: '700',
    lineHeight: '24px'
  },
  displayExtraSmallMedium: {
    fontFamily,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: '20px'
  },
  textLargeNormal: {
    fontFamily,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: '20px'
  },
  textLargeMedium: {
    fontFamily,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: '20px'
  },
  textLargeSemibold: {
    fontFamily,
    fontSize: 16,
    fontWeight: '600',
    lineHeight: '20px'
  },
  textLargeBold: {
    fontFamily,
    fontSize: 16,
    fontWeight: '700',
    lineHeight: '20px'
  },
  textRegularNormal: {
    fontFamily,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '20px'
  },
  textRegularMedium: {
    fontFamily,
    fontSize: 14,
    fontWeight: '500',
    lineHeight: '20px'
  },
  textRegularSemibold: {
    fontFamily,
    fontSize: 14,
    fontWeight: '600',
    lineHeight: '20px'
  },
  textRegularBold: {
    fontFamily,
    fontSize: 14,
    fontWeight: '700',
    lineHeight: '20px'
  },
  textMiniNormal: {
    fontFamily,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: '18px'
  },
  textMiniMedium: {
    fontFamily,
    fontSize: 12,
    fontWeight: '500',
    lineHeight: '18px'
  },
  textMiniSemibold: {
    fontFamily,
    fontSize: 12,
    fontWeight: '600',
    lineHeight: '18px'
  },
  textMiniBold: {
    fontFamily,
    fontSize: 12,
    fontWeight: '700',
    lineHeight: '18px'
  },
  textMicroNormal: {
    fontFamily,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: '14px'
  },
  textMicroMedium: {
    fontFamily,
    fontSize: 12,
    fontWeight: '500',
    lineHeight: '14px'
  },
  textMicroSemibold: {
    fontFamily,
    fontSize: 12,
    fontWeight: '600',
    lineHeight: '14px'
  },
  textMicroBold: {
    fontFamily,
    fontSize: 12,
    fontWeight: '700',
    lineHeight: '14px'
  },
  textNanoNormal: {
    fontFamily,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: '14px'
  },
  heading: {
    fontFamily,
    fontSize: 20,
    fontWeight: '600',
    lineHeight: '24px'
  },
  subheading: {
    fontFamily,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: '20px'
  },
  body: {
    fontFamily,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '20px'
  },
  base: {
    fontFamily,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '20px'
  }
};
